// Module
var code = "<div class=\"news-item no-results\"> <div class=\"news-container\"> <p>There's nothing scheduled at the moment. Keep checking back!</p> </div> </div>";
// Exports
export default code;